export default __webpack_public_path__ + "static/luxor-management-logo-091c497c331caa3e4e21726dff9f980e.svg";